import { DEFAULTS } from "./defaults";
import { nodeViewDecorators } from "./nodeViewDecorators";
import { LINK_TYPE } from "./types";
const pluginLink = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: LINK_TYPE,
    nodeViewDecorators
  };
};
export {
  pluginLink
};
//# sourceMappingURL=viewer.js.map
